<template>
  <div class="follow-page detail page-padding-top">
    <top-bar :title="i18n.t(`tradeFollow.title${pageType}`)"  @back="back"></top-bar>
    <div class="follow-home" >

      <div class="user-list">
        <div class="list auto" >
          <div class="flex-center info">
            <div class="header">{{detailData.Name.substring(0, 1)}}</div>
            <div class="flex-1">
              <div class="name flex-center-start">
                 <span>{{resetName(detailData.Name)}}</span>
                <img :src="levelObj[`url${1}`]" alt="">
              </div>
              <div class="email">
                {{resetEmail(detailData.Email)}}
              </div>
            </div>
          </div>
          <div class="flex-wrap user-statistics">
            <div class="box flex-column-center ">
              <div class="label">{{$t('follow.label1')}}(USDT)</div>
              <div class="count green">{{detailData.TotalProfit.toFixed(2)}}</div>
            </div>
            <div class="box flex-column-center ">
              <div class="label">{{$t('follow.label2')}}</div>
              <div class="count ">{{detailData.TotalTrade}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="space-line"></div>
    </div>

    <div class="follow-trade">
      <div class="form-label">{{$t('tradeFollow.label1')}}</div>
      <div class="form-input">
        <input type="number" inputmode="decimal" v-model="form.InvestmentAmount" :placeholder="$t('tradeFollow.placeholder1')">
      </div>
      <div class="form-desc flex-center-start">
        <span>{{$t('tradeFollow.label5')}}</span>
        <span class="count">{{parseFloat(userMoney).toFixed(4)}} USDT</span>
        <span class="btn" @click="toPath('transfer')">{{$t('tradeFollow.label6')}}</span>
      </div>

      <div class="form-label">{{$t('tradeFollow.label2')}}</div>
      <div class="form-input">
        <input type="number" inputmode="decimal" v-model="form.PeriodAmount" :placeholder="$t('tradeFollow.placeholder2')">
      </div>

      <div class="form-label">{{$t('tradeFollow.label3')}}</div>
      <div class="form-input">
        <input type="number" inputmode="decimal" v-model="form.ProfitAmountStop" :placeholder="$t('tradeFollow.placeholder3')">
      </div>

      <div class="form-label">{{$t('tradeFollow.label4')}}</div>
      <div class="form-input">
        <input type="number" inputmode="decimal" v-model="form.LossAmountStop" :placeholder="$t('tradeFollow.placeholder4')">
      </div>
    </div>
    
    <Button class="bottom-btn" @click="submit">{{$t('followDetail.btn')}}</Button>
  </div>
</template>
<script>
import { Button, Tabs, Tab } from 'vant'
import topBar from '@/components/topBar'
import { wallet } from '@/api/assest'
import { copyTradeJoin } from '@/api/trade'
import { resetName, resetEmail } from '@/utils/common'
export default {
  name: 'home',
  components: {
    topBar,
    Button,
    Tabs,
    Tab
  },
  data() {
    return {
      form: {
        InvestmentAmount: '',
        PeriodAmount: '',
        ProfitAmountStop: '',
        LossAmountStop: '',
      },
      pageType: 3, //1 现货； 2期权； 3 合约
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      homeUrl: require('../../assets/imgs/follow-home.png'),
      homeUrl2: require('../../assets/imgs/follow-home2.png'),
      userUrl: require('../../assets/imgs/follow-user.png'),
      userUrl2: require('../../assets/imgs/follow-user2.png'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      menuUrl1: require('../../assets/imgs/icon-transfer3.png'),
      menuUrl2: require('../../assets/imgs/icon-debt.png'),
      emptyUrl: require('../../assets/imgs/order-empty.png'),
      levelObj: {
        url1: require('../../assets/imgs/level1.png'),
        url2: require('../../assets/imgs/level2.png'),
      },
      showMoney: false,
      userMoney: 0,
      detailData: {
        TotalProfit: 0,
        TotalTrade: 0
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
     moneyStr() {
      return this.showMoney ? parseFloat(this.userMoney).toFixed(4) : '****'
    },
    tabList() {
      return [`${this.$t('followDetail.tab1')}`, this.$t('followDetail.tab2'), this.$t('followDetail.tab3'), this.$t('followDetail.tab4')]
    }
  },
  mounted() {
    let index =  sessionStorage.getItem('followIndex')
    this.tabIndex = index || 1

    let data = sessionStorage.getItem('copyTradeData')
    if (data) {
      this.detailData = JSON.parse(data)
    }

    this.init()
  },
  methods: {
    resetEmail,
    resetName,
    init() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 10)
      form.append('ShortName', 'usdt')
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          this.userMoney = data.FollowUse
        }
      })
    },
    changeTab(i) {
      this.tabIndex = i
      sessionStorage.setItem('followIndex', i)
    },
    back() {
      this.$router.go(-1)
      sessionStorage.setItem('followIndex', 1)
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    changeType(type) {
      this.userType = type
    },
    submit() {
      if (!this.form.InvestmentAmount) {
        this.$toast.fail(this.$t('tradeFollow.placeholder1'))
        return
      }
      if (!this.form.PeriodAmount) {
        this.$toast.fail(this.$t('tradeFollow.placeholder2'))
        return
      }
      if (!this.form.ProfitAmountStop) {
        this.$toast.fail(this.$t('tradeFollow.placeholder3'))
        return
      }
      if (!this.form.LossAmountStop) {
        this.$toast.fail(this.$t('tradeFollow.placeholder4'))
        return
      }
      let form = new FormData()
      form.append('InvestmentAmount', this.form.InvestmentAmount)
      form.append('PeriodAmount', this.form.PeriodAmount)
      form.append('ProfitAmountStop', this.form.ProfitAmountStop)
      form.append('LossAmountStop', this.form.LossAmountStop)
      form.append('CopyTradingSettingsId', this.detailData.ID)
      copyTradeJoin(form).then(res => {
        if (res.code == 0) {
          this.$toast.success(this.$t('tradeFollow.success'))
          this.form = {
            InvestmentAmount: '',
            PeriodAmount: '',
            ProfitAmountStop: '',
            LossAmountStop: '',
          }
          this.init()
        } else {  
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>